import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareCampanie } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareCampanie() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareCampanie,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.tinte() });
    },
  });
}
